// components
import CommonActionModal from "../Common/CommonActionModal";
import SliceTaskAdd from "./SliceTaskAdd";

// icons
import SummarizeIcon from '@mui/icons-material/Summarize';
import AddCircleIcon from '@mui/icons-material/AddCircle';


class SliceTaskAddModal extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            button: {
                icon: AddCircleIcon,
                color: 'primary',
                label: 'Добавить'
            },
            ready: true,
            flat: true,
            width: 'calc(80vw)',
        })
    }

    async beforeModalOpen(){
        return {
            modalLabel: 'Добавление задач в срез',
            modalIcon: SummarizeIcon,
            mainComponent: SliceTaskAdd,
            mainComponentProps: {
                slice: this.props.slice,
                callBack: this.addTasks.bind(this),
            },
        }
    }

    async addTasks(){
        if (this.props.callBack){
            await this.props.callBack()
        }
        this.setModalOpenFalse()
    }
}

export default SliceTaskAddModal